<div *ngIf="providerState && !error" class="fw-light my-2">
  Validating session state...
  elapsed = {{elapsed}}
</div>
<error-panel
  [error]="error"
></error-panel>
